import { type FieldTypeConfig, JsonSchemaType } from './types';

export const number: FieldTypeConfig = {
  toJsonSchema: () => ({
    type: JsonSchemaType.Number,
  }),
};
